// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "._3sa8ZH7_UBDMPjY8qvqldV {\n  fill: #0055aa;\n  fill-opacity: 0.6;\n}\n\n._3kHOQUKzOrJ6QduWzwEH7k {\n  fill: #00aa55;\n  fill-opacity: 0.6;\n}\n\n.OjG9W-5GuHygWN44XI7SP {\n  font-size: 10pt;\n}\n\n.c-FKg8Fk6xoxyXVrCnWP6 {\n  text-align: center;\n}\n", "",{"version":3,"sources":["HeightGraph.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,kBAAA;AACF","file":"HeightGraph.css","sourcesContent":[".general {\n  fill: #0055aa;\n  fill-opacity: 0.6;\n}\n\n.specific {\n  fill: #00aa55;\n  fill-opacity: 0.6;\n}\n\n.legend {\n  font-size: 10pt;\n}\n\n.container {\n  text-align: center;\n}\n"]}]);
// Exports
exports.locals = {
	"general": "_3sa8ZH7_UBDMPjY8qvqldV",
	"specific": "_3kHOQUKzOrJ6QduWzwEH7k",
	"legend": "OjG9W-5GuHygWN44XI7SP",
	"container": "c-FKg8Fk6xoxyXVrCnWP6"
};
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader/dist/cjs.js??ref--1-1!../node_modules/postcss-loader??ref--1-2!./components/HeightGraph/HeightGraph.css
// module id = 574
// module chunks = 37